// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_dWm","cls2":"News-cls2_55d News-cls1_dWm","variant-dense":"News-variant-dense_Zpj"};